import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../core/services/widgetService.js";
import NumberAbbreviator from "../../../../core/utils/numberAbbreviator.js";

const Controller = require('./controller.js');
const gagueWidthHeightRatio = 1.65;

export default class GaugeWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.componentId = props.componentId;
    this.controller = new Controller(props.componentId, props.widget.id, props.legends);
    this.isAnimating = false;
    this.lastUpdatedValue = 0;
    this.max = 0;
  }

  componentDidMount() {
    this.$container = $(this.refs.gaugeOuterWrapper);
    this.resolveDependencies()
      .then(() => {
        this.controller.addUpdateListener((data) => this.update(data));
        WidgetService.addComponentToWidget(this.props.widgetId, this.controller, {max: this.props.max});
        this.renderGauge();
        this.handleResize({widget: this.$container.parents("li")});
      });
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE, payload => this.handleResize(payload));
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE_STOP, payload => this.handleResize(payload));
  }

  componentWillUnmount() {
    this.unsubscribeAll();
    this.controller.destroy();
  }

  resolveDependencies() {
    return new Promise((resolve, reject) => {
      try {
        require.ensure([], require => {
          require('../../../../vendors/justgage/eve.js');
          window.Raphael = require('../../../../vendors/justgage/raphael.2.2.0.js');
          require('../../../../vendors/justgage/justgage.1.2.2.js');
          resolve();
        });
      }
      catch (err) {
        reject(err);
      }
    });
  }

  renderGauge() {
    $('#' + this.props.componentId).empty();

    let levelColors = ["#a9d70b", "#f9c802", "#ff0000"];

    if(this.props.widget.legends[0].parameters.minColor && this.props.widget.legends[0].parameters.maxColor) {
      levelColors = [this.props.widget.legends[0].parameters.minColor, this.props.widget.legends[0].parameters.maxColor];
    }

    this.gaugeController = new JustGage({
      id: this.props.componentId,
      value: this.lastUpdatedValue,
      min: 0,
      max: this.props.max || 1,
      showInnerShadow: false,
      refreshAnimationTime: 1500,
      textRenderer: NumberAbbreviator.format,
      startAnimationTime: 0,
      relativeGaugeSize: true,
      titlePosition: "below",
      valueFontFamily: "Roboto",
      levelColors: levelColors
    });
  }

  update(newData) {
    if (isNaN(newData) || newData == null) return;
    let _this = this;
    var max = this.props.legends[0].parameters.chartTypeParameters.max;

    if (this.max < max) {
      this.max = max;
    }

    if (!this.isAnimating && !this.isResizing) {
      this.isAnimating = true;
      this.lastUpdatedValue = newData;

      if (newData > this.max) {
        this.max = newData;
      }

      this.gaugeController.refresh(newData, this.max);
      setTimeout(function () {
        _this.isAnimating = false;
        if (_this.needToUpdateLatest) {
          _this.needToUpdateLatest = false;
          _this.controller.update();
        }
      }, 1700);
    } else {
      this.needToUpdateLatest = true;
    }
  }

  handleResize(payload) {
    //if(_this.resizeTimer) clearTimeout(_this.resizeTimer);
    var mobileBodyContainer = $(".dashboard-body-mobile");
    if (mobileBodyContainer.length > 0) {
      if (mobileBodyContainer.width() / 2 > mobileBodyContainer.height() - 100) {
        var width = (mobileBodyContainer.height() - 30) * 2;
        var marginLeft = (mobileBodyContainer.width() - width) / 2;
        this.$container.css({"width": width, "margin-left": marginLeft, "margin-top": "-30px"});
      } else {
        this.$container.css({"width": "100%", "margin-left": "0%", "margin-top": 0});
      }
    }

    // maximize toggle
    if (payload != null) {
      let widgetId = $(payload.widget).find("div[data-widget-id]").attr("data-widget-id");
      if (this.props.widgetId != widgetId) return;

      if (payload.maximized) {
        let width = payload.height * 1.4;
        this.$container.css({"min-width": width, "max-width": width, "align-self": "center"});
      } else {
        let height = $(payload.widget).height();

        let width = $(payload.widget).width();
        let svgHeight = this.$container.height();

        let ratio = width / height;
        if (ratio > gagueWidthHeightRatio) {
          let maxWidth = height * gagueWidthHeightRatio;
          this.$container.css({
            "min-width": "",
            "max-width": maxWidth + 'px',
            "align-self": "",
            "margin-left": (width - maxWidth) / 2,
            "margin-top": ""
          });
        } else {
          let style = {
            "min-width": "",
            "max-width": "",
            "align-self": "",
            "margin-left": ""
          };
          let verticalSpace = height - svgHeight;
          // if (this.props.doesTitleExist) verticalSpace -= 32;
          if (verticalSpace > 0) {
            style["margin-top"] = verticalSpace / 2;
          }
          this.$container.css(style);

        }
      }
    }
  }

  render() {
    const style = {
      overflow: "hidden",
      position: "relative",
      paddingTop: this.props.widget.title.length > 0 ? "20px" : 0,
      maxHeight: "100%",
      width: "100%",
      display: "inline-block"
    };
    const style2 = {};
    if (this.props.isAddWidget) {
      style.paddingTop = 0;
      style.maxHeight = "100%";
      style2.maxWidth = "250px";
      style2.margin = "20px auto";
    }
    return (
      <div style={style}>
        <div className="gaugeOuterWrapper" ref="gaugeOuterWrapper" id={this.props.componentId} style={style2}>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/gauge/gaugeWidget.jsx